import { Injectable } from '@angular/core';
import { DataMaintenanceModel, ENDPOINTS, getUuidV4, OdataService } from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OdataDataMaintenanceService {
    public constructor(private readonly odataService: OdataService) {}

    public sendDataMaintenanceEquipment(dataMaintenance: DataMaintenanceModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            dataMaintenance,
            ENDPOINTS.DataMaintenanceEquipment,
            `${dataMaintenance.notificationIdentifier.toString()}-${getUuidV4()}`,
        );
    }
}
